if (!window.productFormInitialized) {
  window.productFormInitialized = true;
  document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.product-form-snippet form');
    
    forms.forEach(productForm => {
      // Prevent multiple initialization of the same form
      if (productForm.dataset.initialized) return;
      productForm.dataset.initialized = 'true';

      const variantRadios = productForm.querySelectorAll('input[name="id"]');
      const addToCartBtn = productForm.querySelector('[type="submit"]');
      const qtyInput = productForm.querySelector('#quantity');
      const qtyMinus = productForm.querySelector('.qty-minus');
      const qtyPlus = productForm.querySelector('.qty-plus');

      function updateVariantState(radio) {
        const variantId = radio.value;

        // Sync hidden inputs with name="id" within the same form
        productForm.querySelectorAll('input[name="id"]').forEach(input => {
          if (input.type === 'hidden') {
            input.value = variantId;
          }
        });

        // Clear stock error when variant changes
        const errorEl = productForm.querySelector('.cart-qty-error');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.style.display = 'none';
        }

        const isAvailable = radio.dataset.available === 'true';
        // 'coming-soon' product that still holds stock: nothing to notify about, so the
        // button neither adds to cart nor triggers the Klaviyo back-in-stock form.
        const isComingSoonBlocked = radio.dataset.comingSoonBlocked === 'true';

        productForm.querySelectorAll('.swatch-item, .shoes-size-item').forEach(el => {
          el.classList.remove('active');
        });
        const swatchParent = radio.closest('.swatch-item, .shoes-size-item');
        if (swatchParent) swatchParent.classList.add('active');

        // Remove select-size warning once a variant is picked
        addToCartBtn.classList.remove('select-size');

        // Gift card: update displayed price to selected variant price
        const priceWrapper = addToCartBtn.querySelector('.price-wrapper[data-gift-card]');
        if (priceWrapper && radio.dataset.price) {
          const regularPriceEl = priceWrapper.querySelector('.regular-price');
          if (regularPriceEl) regularPriceEl.textContent = radio.dataset.price;
        }

        // Update variant ID on the button
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-variant-id', radio.value);
        }

        // Update button text
        const btnTextSpan = addToCartBtn.querySelector('.right span:first-child');
        const isStoreExclusive = addToCartBtn.classList.contains('store-exclusive-copy');
        if (isComingSoonBlocked) {
          addToCartBtn.classList.add('coming-soon-blocked');
          addToCartBtn.classList.remove('sold-out', 'klaviyo-bis-trigger');
          addToCartBtn.setAttribute('aria-disabled', 'true');
          addToCartBtn.setAttribute('aria-label', addToCartBtn.dataset.comingsoonText || 'Coming soon');
        } else if (!isAvailable && !isStoreExclusive) {
          addToCartBtn.classList.remove('coming-soon-blocked');
          addToCartBtn.classList.add('sold-out', 'klaviyo-bis-trigger');
          addToCartBtn.removeAttribute('aria-disabled');
          addToCartBtn.setAttribute('aria-label', addToCartBtn.dataset.soldoutText || 'Sold out');
          if (btnTextSpan) btnTextSpan.textContent = addToCartBtn.dataset.soldoutText || 'Sold out';
        } else {
          addToCartBtn.classList.remove('coming-soon-blocked', 'sold-out', 'klaviyo-bis-trigger');
          addToCartBtn.removeAttribute('aria-disabled');
          addToCartBtn.setAttribute('aria-label', addToCartBtn.dataset.addText || 'Add to cart');
          if (btnTextSpan) btnTextSpan.textContent = addToCartBtn.dataset.addText || 'Add to cart';
        }

        // Update sticky bar price specifically
        const stickyPrice = document.querySelector('.sticky-price');
        if (stickyPrice && radio.dataset.price) {
          stickyPrice.textContent = radio.dataset.price;
        }

        // Sync with other forms
        document.querySelectorAll(`input[name="id"]`).forEach(input => {
          if (input.closest('form') === productForm) return;

          if (input.type === 'radio' || input.type === 'checkbox') {
            if (input.value === variantId) {
              input.checked = true;
              const otherForm = input.closest('form');
              if (otherForm) {
                // Update UI state list for the other form
                otherForm.querySelectorAll('.swatch-item, .shoes-size-item').forEach(el => el.classList.remove('active'));
                const otherParent = input.closest('.swatch-item, .shoes-size-item');
                if (otherParent) otherParent.classList.add('active');

                // Update button for other form
                const otherBtn = otherForm.querySelector('[type="submit"]');
                if (otherBtn) {
                  otherBtn.setAttribute('data-variant-id', variantId);
                  otherBtn.classList.remove('select-size');
                  if (isComingSoonBlocked) {
                    otherBtn.classList.add('coming-soon-blocked');
                    otherBtn.classList.remove('sold-out', 'klaviyo-bis-trigger');
                  } else {
                    otherBtn.classList.remove('coming-soon-blocked');
                    if (!isAvailable) otherBtn.classList.add('sold-out');
                    else otherBtn.classList.remove('sold-out');
                  }
                  const otherBtnText = otherBtn.querySelector('.right span:first-child');
                  if (otherBtnText && !isComingSoonBlocked) {
                    const otherIsStoreExclusive = otherBtn.classList.contains('store-exclusive-copy');
                    otherBtnText.textContent = (isAvailable || otherIsStoreExclusive) ? (otherBtn.dataset.addText || 'Add to cart') : (otherBtn.dataset.soldoutText || 'Sold out');
                  }
                }
              }
            }
          } else if (input.type === 'hidden') {
            input.value = variantId;
          }
        });
      }

      variantRadios.forEach(radio => {
        radio.addEventListener('change', () => updateVariantState(radio));
      });

      const checkedVariant = productForm.querySelector('input[name="id"]:checked');
      if (checkedVariant) updateVariantState(checkedVariant);

      if (qtyPlus) {
        qtyPlus.addEventListener('click', () => {
          qtyInput.value = parseInt(qtyInput.value, 10) + 1;
        });
      }

      if (qtyMinus) {
        qtyMinus.addEventListener('click', () => {
          const current = parseInt(qtyInput.value, 10);
          if (current > 1) qtyInput.value = current - 1;
        });
      }

      /* ── AJAX add to cart → open drawer ─────────────────────── */
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const selectedVariant = productForm.querySelector('input[name="id"]:checked');
        if (!selectedVariant) {
          addToCartBtn.classList.add('select-size');
          return;
        }

        // 'coming-soon' products are never purchasable, including via the sticky bar's
        // programmatic click, which bypasses the button's pointer-events: none.
        if (
          addToCartBtn.classList.contains('coming-soon-blocked') ||
          selectedVariant.dataset.comingSoonBlocked === 'true'
        ) {
          return;
        }

        const errorEl = productForm.querySelector('.cart-qty-error');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.style.display = 'none';
        }

        const variantId = selectedVariant.value;
        const addQty    = parseInt(qtyInput.value || 1, 10) || 1;
        let errorTimeout;

        function showError() {
          if (errorEl) {
            const msg = errorEl.dataset.maxQty || 'The maximum quantity of this item is already in your cart.';
            errorEl.textContent = msg;
            errorEl.style.display = 'block';
            clearTimeout(errorTimeout);
            errorTimeout = setTimeout(() => {
              errorEl.style.display = 'none';
            }, 3000);
          }
        }

        // Check availability versus cart
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartItem = cart.items.find(item => item.variant_id == variantId);
          const currentInCart = cartItem ? cartItem.quantity : 0;
          
          return fetch(`/variants/${variantId}.js`)
          .then(res => res.json())
          .then(variantData => {
            // PROACTIVE CHECK: If variant has inventory tracking and we exceed it, stop immediately
            if (variantData.inventory_management && 
                variantData.inventory_policy === 'deny' && 
                (currentInCart + addQty) > variantData.inventory_quantity) {
              
              showError();
              return; // STOP execution here
            }
            
            addToCartBtn.disabled = true;

            const properties = {};
            productForm.querySelectorAll('input[name^="properties["]').forEach(input => {
              const match = input.name.match(/^properties\[(.+)\]$/);
              if (match && input.value.trim()) {
                properties[match[1]] = input.value.trim();
              }
            });

            const cartPayload = { id: variantId, quantity: addQty };
            if (Object.keys(properties).length > 0) cartPayload.properties = properties;

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(cartPayload)
            })
            .then(response => {
              if (!response.ok) return response.json().then(d => { throw d; });
              return response.json();
            })
            .then(() => {
              // If sticky drawer is open, close it
              const stickyDrawer = document.querySelector('.sticky-atc-drawer');
              if (stickyDrawer) {
                stickyDrawer.classList.remove('is-open');
                const overlay = document.querySelector('.sticky-atc-drawer-overlay');
                if (overlay) overlay.classList.remove('is-open');
                document.body.style.overflow = '';
              }

              if (typeof load_cart === 'function') {
                load_cart().then(() => {
                  if (typeof openCartDrawer === 'function') openCartDrawer();
                });
              } else {
                if (typeof openCartDrawer === 'function') openCartDrawer();
              }
            })
            .catch(err => {
              console.error('Add to cart error:', err);
              const errMsg = (err.description || err.message || '').toLowerCase();
              if (err.status == 422 || errMsg.includes('all') || errMsg.includes('already') || errMsg.includes('cannot add')) {
                 showError();
              } else if (err && (err.description || err.message)) {
                alert(err.description || err.message);
              }
            })
            .finally(() => {
              addToCartBtn.disabled = false;
            });
          });
        });
      });
    });
  });
}